import { 
   createAdPostAttemptsLoading, 
   createAdPostAttemptsSuccess, 
   createAdPostAttemptsFailure 
} from "@redux/slices/adPostAttemptsSlice.js"
import { createAdPostAttempts } from "@services/adPostAttempts/createAdPostAttempts"
import { useDispatch } from "react-redux"

const useAdPostAttempts = () => {
   const dispatch = useDispatch()

   const handleCreateAdPostAttempt = async (attemptData) => {
      try {
         dispatch(createAdPostAttemptsLoading())
         const response = await createAdPostAttempts(attemptData)
         dispatch(createAdPostAttemptsSuccess(response.data))
         return response.data
      } catch (error) {
         dispatch(createAdPostAttemptsFailure())
         console.log(error)
         throw error
      }
   }

   return { handleCreateAdPostAttempt }
}

export default useAdPostAttempts 